import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { Password, Button, Layout, Toast, } from "@app/components";
import { FormFlexWrapper, FlexWrapper, SpinnerSpan, GenaratePassword } from "@app/components/commonStyles";
import { updateUser, generateStudentPassword } from "@app/services";
import { passwordPattern, useLocation } from "@app/utils";
import { AuthContext } from "@app/providers";
import { getDefaultUrl } from "@app/routes/route-helpers";
import { ButtonContainer, NewPasswordLabel } from "./change-password-component";
import LoaderIcon from "@app/components/icon/icons/loader-icon";
import InfoCircleIcon from "@app/components/icon/icons/info-circle-icon";
// import bcrypt from "bcrypt";

export default function ChangePassword() {
  const { register, handleSubmit, watch, errors, getValues, trigger } =
    useForm();
  const { userInfo, setUserInfo } = useContext(AuthContext);
  const defaultUrl: string = getDefaultUrl(userInfo.userJson);
  const { navigate } = useLocation();
  const [buttonText, setButtonText] = useState<string>("Update");
  const [showToast, setShowToast] = React.useState(false);
  const userToken = userInfo && userInfo.sessionToken;
  const [spinner, setSpinner] = useState(false);
  const [studentPassword, setStudentPassword] = useState<any>({
    password: "",
  });
  const [hideIcon, setHideIcon] = useState(true)
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const base64 = require('base-64');

  function onPasswordBlur() {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
  }

  async function onSubmit(data: any) {
    const params: any = {};
    const {
      sessionToken = "",
      userJson: { userId = "", userType = "" },
    } = userInfo;
    Object.assign(params, {
      userId: userId,
      userType: userType,
      sessionToken: sessionToken,
      oldPassword: data.oldPassword,
      password: data.password,
      confirmPassword: data.confirmPassword
    });
    setButtonText("Updating...");

    updateUser(params)
      .then((response: any) => {
        setButtonText("Update");
        if (response._responseStatus === 1) {
          setToastMessage({
            type: "success",
            message: `Password updated successfully.`,
          });
          setShowToast(true);
          setTimeout(() => {
            const defaultUrl: string = getDefaultUrl(response.userJson);
            navigate(defaultUrl);
          }, 500);
        } else if (response.msgCode === "SSN_002") {
          setShowToast(true);
          setToastMessage({
            type: "error",
            message: response.msg,
          });

          setTimeout(() => {
            localStorage.clear();
            setUserInfo(null);
            navigate("/sign-in");
          }, 5000);
        } else {
          setToastMessage({
            type: "error",
            message: "Current password does not match",
          });
          setShowToast(true);
        }
      })
      .catch((err: any) => {
        console.log(err);
        setButtonText("Update");
        setToastMessage({
          type: "error",
          message: `Something went wrong, Please try again`,
        });
        setShowToast(true);
      });

  }

  function generatePassword() {
    setHideIcon(false)
    const params: any = {};
    Object.assign(params, {
      sessionToken: userToken,
      userId: userInfo && userInfo.userJson.userId,
      update: 1
    });
    setSpinner(true)
    generateStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          setHideIcon(true)
          setSpinner(false);
          setStudentPassword({
            password: base64.decode(response.studentPassword)
          });
          setToastMessage({
            type: "success",
            message: "Student Password updated Successfully",
          });
          setShowToast(true);
        }
        else {
          setToastMessage({
            type: "error",
            message: "Failed to reset Password",
          });
          setShowToast(true);
          setSpinner(false);
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: "Something went wrong",
        });
        setShowToast(true);
      })
  }

  return (
    <>
      <Layout className={userInfo.userJson.userType !== 'student' ? 'flexed aligned-center' : 'flexed aligned-center forget-password-box'}>
        <h3 className="primary-header text-center mb-3">Change Password</h3>
        {userInfo.userJson.userType !== 'student' &&
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormFlexWrapper className="mb-0">
              {(!userInfo.userJson.cleverAccountId || (userInfo.userJson.cleverAccountId && userInfo.userJson.cleverAccountId !== '' && (!userInfo.userJson.passwordResetNotDone || userInfo.userJson.userType === 'student'))) &&
                <div className="child only-child">
                  <Password
                    hideLabel={false}
                    label="Current Password"
                    placeholder="Current Password"
                    hideIcon={true}
                    name="oldPassword"
                    register={register({
                      required: true,
                    })}
                    autoFocus={true}
                    error={errors.oldPassword && "Please enter Current Password"}
                  />
                </div>}
            </FormFlexWrapper>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <NewPasswordLabel >New Password </NewPasswordLabel>
                {userInfo.userJson.cleverAccountId && userInfo.userJson.cleverAccountId !== '' &&
                  <span className="custTooltip">
                    <InfoCircleIcon ></InfoCircleIcon>
                    {(!userInfo.userJson.passwordResetNotDone || userInfo.userJson.userType === 'student') ?
                      <span>We are updating KazooBadoo password only but not Clever.</span> :
                      <span>In addition to logging in through Clever or Google Classroom you can also create a KazooBadoo password. If you would like please enter your password below.</span>
                    }
                  </span>
                }
                <Password
                  hideLabel={false}
                  hideIcon={true}
                  placeholder="New Password"
                  name="password"
                  showInfo={false}
                  showInstructions={true}
                  register={register({
                    required: true,
                    pattern: passwordPattern,
                  })}
                  onBlur={onPasswordBlur}
                  error={
                    (errors.password &&
                      errors.password.type === "required" &&
                      "Please enter New Password") ||
                    (errors.password &&
                      errors.password.type === "pattern" &&
                      "Please enter a Strong Password")
                  }
                />
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <Password
                  hideLabel={false}
                  hideIcon={true}
                  label="Confirm Password"
                  placeholder="Confirm Password"
                  name="confirmPassword"
                  register={register({
                    required: true,
                    validate: (value: any) => {
                      return value === watch("password");
                    },
                  })}
                  error={
                    (errors.confirmPassword &&
                      errors.confirmPassword.type === "required" &&
                      "Please confirm Password") ||
                    (errors.confirmPassword &&
                      errors.confirmPassword.type === "validate" &&
                      "Passwords did not match")
                  }
                />
              </div>
            </FormFlexWrapper>
            <FlexWrapper className='justify-end'>
              <Button
                variant="text"
                customClass="mr-1 mr-sm-0 mb-sm-1"
                type="button"
                onClick={() => navigate(defaultUrl)}
                disabled={userInfo.userJson.userType === 'student' && userInfo.userJson.passwordResetNotDone && userInfo.userJson.passwordResetNotDone === true}
              >
                Cancel
              </Button>
              <ButtonContainer
                disabled={buttonText === "Updating..."}
                style={{ width: "unset" }}
              >
                <Button variant="newsecondary" type="submit">
                  {buttonText}
                </Button>
              </ButtonContainer>
            </FlexWrapper>
          </form>
        }

        {userInfo.userJson.userType === 'student' &&
          <GenaratePassword>
            <FormFlexWrapper className="mb-0">
              <div className="child only-child">
                <p className="anchor-tag mb-10" onClick={() => generatePassword()}>
                  Generate Password
                </p>
                <Password
                  hideLabel={false}
                  // label="New Password"
                  placeholder="New Password"
                  name="genpassword"
                  value={studentPassword.password ? studentPassword.password : ''}
                  defaultPasswordvisiblility={true}
                  hideIcon={hideIcon}
                  disable={true}
                // onBlur={}
                />
              </div>

            </FormFlexWrapper>

            {spinner &&
              <div style={{ position: "relative" }}>
                <SpinnerSpan>
                  <LoaderIcon style={{ width: '30px' }} />
                </SpinnerSpan>
              </div>
            }
          </GenaratePassword>
        }


        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          title="Update Password"
          onClose={() => setShowToast(false)}
        />

      </Layout>
    </>
  );
}
